// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "client_package_item".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "client_package_item" table (1:1 with a DB row, on the wire). */
export const clientPackageItemAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    clientPackageId: z.string(),
    serviceId: z.string().nullable(),
    serviceName: z.string(),
    sortOrder: z.number(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=clientPackageItem.js.map